import { render, staticRenderFns } from "./wait_config.vue?vue&type=template&id=9813b74a&scoped=true&"
import script from "./wait_config.vue?vue&type=script&lang=js&"
export * from "./wait_config.vue?vue&type=script&lang=js&"
import style0 from "./wait_config.vue?vue&type=style&index=0&id=9813b74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9813b74a",
  null
  
)

export default component.exports